export const CERTIFICATE_TEMPLATE_EXAMPLE = 'CERTIFICATE_TEMPLATE_EXAMPLE'
export const CERTIFICATE_TEMPLATE_ANOTHER_EXAMPLE = 'CERTIFICATE_TEMPLATE_ANOTHER_EXAMPLE'

export const CERTIFICATE_TEMPLATE_ALL = [CERTIFICATE_TEMPLATE_EXAMPLE, CERTIFICATE_TEMPLATE_ANOTHER_EXAMPLE]
